<template>
  <div ref="echartRef" :style="`width: ${props.width}; height: ${props.height}`"></div>
</template>
<script lang="ts" setup name="SmartEchart">
import { ref, onMounted, watch } from 'vue'
import * as echarts from 'echarts'

const echartRef = ref()

const props = defineProps({
  width: {
    type: [Number, String],
    default: '500px'
  },
  height: {
    type: [Number, String],
    default: '300px'
  },
  options: {
    type: Object,
    default: () => ({})
  }
})

watch(props.options, (newVal) => {
  const myChart = echarts.init(echartRef.value)
  myChart.setOption(newVal)
  myChart.resize()
})

onMounted(() => {
  const myChart = echarts.init(echartRef.value)
  myChart.setOption(props.options)
  window.onresize = function () {
    myChart.resize()
  }
})
</script>
